export enum LogLevel {
	Off = 0,
	Error,
	Warning,
	Info,
	Debug,
}

export enum NetworkErrorLoggerType {
	XHR = "XHR",
	WS = "WS",
}
